import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DistribuidorMantenedorModel } from '../../models/distribuidorMantenedorModel';
import { ItemModel } from '../../models/itemModel';
import { ReporteModel } from '../../models/reporteModel';
import { CatalogoService } from '../../services/catalogo.service';
import { DistribuidorService } from '../../services/distribuidor.service';
import { distribuidorModulo } from '../../diccionarios/distribuidorModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

@Component({
  selector: 'app-reporte-presupuesto-sell-in',
  templateUrl: './reporte-presupuesto-sell-in.component.html',
  styleUrls: ['./reporte-presupuesto-sell-in.component.css']
})
export class ReportePresupuestoSellInComponent implements OnInit {

  titulo: string = "Reporte Presupuesto SellIn";
  subTitulo: string = "Datos de Consulta";
  distribuidorModulo: any = {};
  formulario: FormGroup;//formulario
  
  loading: boolean = false;
  listaVacia: boolean = true;
  mostrarCard: boolean = true;
  resposiveFull: string;

  columnDefs: any[];//aggrid
  rowData: ItemModel[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  textoBuscar: string;
  
  cmbDistribuidor:any[] = [];
  cmbMes:any[] = [];
  cmbAnio:any[] = [];
  reporteModel: ReporteModel = {
    anio: 0,//2021
    codigoCliente: "",//"259001"
    efectividadMensual: 0,//85
    numeroSemana: 0,//4
    presupuestoVentaSemanal: 0,//125.1775
    totalCantCajas: 0,//15.5
    totalImporte: 0,//500.71
    totalKilos: 0,//36.15
    mes: 0,
  }
  constructor(private fb: FormBuilder, 
              private _util: UtilsService,
              private _distribuidor: DistribuidorService,
              private _catalogo: CatalogoService) { }

  ngOnInit() {
    this.distribuidorModulo = distribuidorModulo;
    this.cmbMes = this._catalogo.catalogoMeses();
    this.formulario = this.fb.group({
      idDistribuidor: ['', [Validators.required]],
      mes: ['', [Validators.required]],
      anio: ['', [Validators.required]]
    });
    this.getDistribuidor();
    this.cargarGrid();
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Item',
        field: 'item',
        filter: true,
        width: 180,
        tooltipField: 'cedula',
        tooltipComponentParams: { color: '#ececec' },
        // cellStyle: this.changeCellColor.bind(this),
      },
      // {
      //   headerName: 'ID Vendedor',
      //   field: 'idVendedorDistribuidor',
      //   sortable: true,
      //   width: 180,
      //   filter: true,
      //   // cellStyle: this.changeCellColor.bind(this),
      // },
      // {
      //   headerName: 'Contenedor',
      //   field: 'contenedor',
      //   sortable: true,
      //   width: 180,
      //   filter: true,
      //   // cellStyle: this.changeCellColor.bind(this),
      // },
      {
        headerName: 'Descripcion',
        field: 'descripcion',
        sortable: true,
        filter: true,
        width: 300,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Pres.Caja',
        field: 'presupuestoCaja',
        sortable: true,
        width: 180,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Pres.Importe',
        field: 'presupuestoImporte',
        sortable: true,
        width: 170,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Pres.Kilo',
        field: 'presupuestoKilo',
        sortable: true,
        width: 170,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  getData() {
    this.loading = true;
    this._distribuidor.getPresupuestoSellIn(this.formulario.value).subscribe((res: ReporteModel) => {
      this.reporteModel = res
      this.rowData = res.items;
      this.loading = false;
      this.listaVacia = (this.rowData.length === 0 ) ? true : false;
    }, (err) => {
      this.reporteModel = {
        anio: 0,//2021
        codigoCliente: "",//"259001"
        efectividadMensual: 0,//85
        numeroSemana: 0,//4
        presupuestoVentaSemanal: 0,//125.1775
        totalCantCajas: 0,//15.5
        totalImporte: 0,//500.71
        totalKilos: 0,//36.15
        mes: 0,
      }
      this.rowData = [];
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErroToast(err.error.mensaje, 2000);
      console.log(err);
    });
  }

  getDistribuidor() {
    this._distribuidor.getDistribuidor().subscribe((res: DistribuidorMantenedorModel[]) => {
      this.cmbDistribuidor = res;
      this.cmbDistribuidor = this.cmbDistribuidor.map((e) => {
        e.descripcion = e.idDistribuidor + ' ' + e.nombreDistribuidor;
        return e;
      });
    }, (err: any) => {
      this.cmbDistribuidor = [];
      console.log(err);
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  
  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

}
